import PropTypes from 'prop-types';
import React from 'react';
import CheckboxCheckedIcon from './icons/CheckboxCheckedIcon';
import CheckboxIndeterminateIcon from './icons/CheckboxIndeterminateIcon';
import CheckboxUncheckedIcon from './icons/CheckboxUncheckedIcon';
import UnstyledButton from './UnstyledButton';
const Checkbox = /*#__PURE__*/React.memo(_ref => {
  let {
    checked = false,
    indeterminate = false,
    size = 16,
    onCheck,
    onUncheck
  } = _ref;
  return indeterminate ? /*#__PURE__*/React.createElement(UnstyledButton, {
    onClick: onCheck,
    color: "blue"
  }, /*#__PURE__*/React.createElement(CheckboxIndeterminateIcon, {
    size: size
  })) : checked ? /*#__PURE__*/React.createElement(UnstyledButton, {
    onClick: onUncheck,
    color: "blue"
  }, /*#__PURE__*/React.createElement(CheckboxCheckedIcon, {
    size: size
  })) : /*#__PURE__*/React.createElement(UnstyledButton, {
    onClick: onCheck,
    sx: {
      '&:hover,&:focus': {
        color: 'blue'
      }
    }
  }, /*#__PURE__*/React.createElement(CheckboxUncheckedIcon, {
    size: size
  }));
});
Checkbox.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
  size: PropTypes.number,
  onCheck: PropTypes.func.isRequired,
  onUncheck: PropTypes.func.isRequired
};
Checkbox.displayName = 'Checkbox';
export default Checkbox;